import angular from 'angular';
import productNotFoundComponent from './product-not-found.component';
import ProductNotFoundService from './product-not-found.service';
import productNotFoundConfig from './product-not-found.config';

let productNotFoundModule = angular.module('productNotFound',[])
  .component('productNotFound', productNotFoundComponent)
  .service('ProductNotFoundService', ProductNotFoundService)
  .config(productNotFoundConfig);

export default productNotFoundModule;



/** WEBPACK FOOTER **
 ** C:/Users/dares/Documents/SIESA_repositorios/himalaya/www/components/catalog/product-not-found/product-not-found.js
 **/